import { CategoryData } from '../../../../types/types';

export const animaux: CategoryData = {
    // Animaux sauvages de la forêt
    'Nkosi (Lion)': {
        translation: 'Lion',
        translationEn: 'Lion',
        illustration: '🦁',
        audio: 'Li-nkosi'
    },
    'Nzoku (Éléphant)': {
        translation: 'Éléphant',
        translationEn: 'Elephant',
        illustration: '🐘',
        audio: 'Li-nzoku'
    },
    'Nkoyi (Panthère/Léopard)': {
        translation: 'Panthère/Léopard',
        translationEn: 'Panther/Leopard',
        illustration: '🐆',
        audio: 'Li-nkoyi'
    },
    'Makako (Singe)': {
        translation: 'Singe',
        translationEn: 'Monkey',
        illustration: '🐒',
        audio: 'Li-makako'
    },
    'Mboloko (Antilope)': {
        translation: 'Antilope',
        translationEn: 'Antelope',
        illustration: '🦌',
        audio: 'Li-mboloko'
    },
    'Mondonga (Girafe)': {
        translation: 'Girafe',
        translationEn: 'Giraffe',
        illustration: '🦒',
        audio: 'Li-mondonga'
    },
    'Mpunda-milia (Zèbre)': {
        translation: 'Zèbre',
        translationEn: 'Zebra',
        illustration: '🦓',
        audio: 'Li-mpunda_milia'
    },
    'Kingbwengi (Hyène)': {
        translation: 'Hyène',
        translationEn: 'Hyena',
        illustration: '🐺',
        audio: 'Li-kingbwengi'
    },

    // Grands singes
    'Mukumbuso (Gorille)': {
        translation: 'Gorille',
        translationEn: 'Gorilla',
        illustration: '🦍',
        audio: 'Li-mukumbuso'
    },
    'Sokwe (Chimpanzé)': {
        translation: 'Chimpanzé',
        translationEn: 'Chimpanzee',
        illustration: '🦧',
        audio: 'Li-sokwe'
    },
    'Makako-monene (Babouin)': {
        translation: 'Babouin',
        translationEn: 'Baboon',
        illustration: '🐒',
        audio: 'Li-makako_monene'
    },

    // Animaux aquatiques
    'Ngubu (Hippopotame)': {
        translation: 'Hippopotame',
        translationEn: 'Hippopotamus',
        illustration: '🦛',
        audio: 'Li-ngubu'
    },
    'Ngando (Crocodile)': {
        translation: 'Crocodile',
        translationEn: 'Crocodile',
        illustration: '🐊',
        audio: 'Li-ngando'
    },
    'Mbisi (Poisson)': {
        translation: 'Poisson',
        translationEn: 'Fish',
        illustration: '🐟',
        audio: 'Li-mbisi'
    },
    'Koba (Tortue)': {
        translation: 'Tortue',
        translationEn: 'Turtle',
        illustration: '🐢',
        audio: 'Li-koba'
    },
    'Lokonga (Anguille)': {
        translation: 'Anguille',
        translationEn: 'Eel',
        illustration: '🐍',
        audio: 'Li-lokonga'
    },

    // Oiseaux
    'Nsoso (Poule)': {
        translation: 'Poule',
        translationEn: 'Hen',
        illustration: '🐔',
        audio: 'Li-nsoso'
    },
    'Mpongo (Aigle)': {
        translation: 'Aigle',
        translationEn: 'Eagle',
        illustration: '🦅',
        audio: 'Li-mpongo'
    },
    'Mukwiti (Perroquet)': {
        translation: 'Perroquet',
        translationEn: 'Parrot',
        illustration: '🦜',
        audio: 'Li-mukwiti'
    },
    'Nkoko (Coq)': {
        translation: 'Coq',
        translationEn: 'Rooster',
        illustration: '🐓',
        audio: 'Li-nkoko'
    },
    'Ekoyo (Corbeau)': {
        translation: 'Corbeau',
        translationEn: 'Crow',
        illustration: '🦅',
        audio: 'Li-ekoyo'
    },

    // Reptiles et amphibiens
    'Nioka (Serpent)': {
        translation: 'Serpent',
        translationEn: 'Snake',
        illustration: '🐍',
        audio: 'Li-nioka'
    },
    'Mongongo (Varan)': {
        translation: 'Varan',
        translationEn: 'Monitor lizard',
        illustration: '🦎',
        audio: 'Li-mongongo'
    },
    'Mbende (Lézard)': {
        translation: 'Lézard',
        translationEn: 'Lizard',
        illustration: '🦎',
        audio: 'Li-mbende'
    },
    'Mpulu (Crapaud)': {
        translation: 'Crapaud',
        translationEn: 'Toad',
        illustration: '🐸',
        audio: 'Li-mpulu'
    },

    // Animaux domestiques
    'Mbwa (Chien)': {
        translation: 'Chien',
        translationEn: 'Dog',
        illustration: '🐕',
        audio: 'Li-mbwa'
    },
    'Nkatu (Chat)': {
        translation: 'Chat',
        translationEn: 'Cat',
        illustration: '🐈',
        audio: 'Li-nkatu'
    },
    'Ngombe (Vache)': {
        translation: 'Vache',
        translationEn: 'Cow',
        illustration: '🐄',
        audio: 'Li-ngombe'
    },
    'Ntaba (Chèvre)': {
        translation: 'Chèvre',
        translationEn: 'Goat',
        illustration: '🐐',
        audio: 'Li-ntaba'
    },
    'Meme (Mouton)': {
        translation: 'Mouton',
        translationEn: 'Sheep',
        illustration: '🐑',
        audio: 'Li-meme'
    },
    'Ngulu (Cochon)': {
        translation: 'Cochon',
        translationEn: 'Pig',
        illustration: '🐷',
        audio: 'Li-ngulu'
    },

    // Insectes et petits animaux
    'Nyoki (Abeille)': {
        translation: 'Abeille',
        translationEn: 'Bee',
        illustration: '🐝',
        audio: 'Li-nyoki'
    },
    'Ngungi (Moustique)': {
        translation: 'Moustique',
        translationEn: 'Mosquito',
        illustration: '🦟',
        audio: 'Li-ngungi'
    },
    'Mpepele (Papillon)': {
        translation: 'Papillon',
        translationEn: 'Butterfly',
        illustration: '🦋',
        audio: 'Li-mpepele'
    },
    'Eyenga (Fourmi)': {
        translation: 'Fourmi',
        translationEn: 'Ant',
        illustration: '🐜',
        audio: 'Li-eyenga'
    },
    'Nzinzi (Mouche)': {
        translation: 'Mouche',
        translationEn: 'Fly',
        illustration: '🪰',
        audio: 'Li-nzinzi'
    },
    'Nyama-nyama (Araignée)': {
        translation: 'Araignée',
        translationEn: 'Spider',
        illustration: '🕷️',
        audio: 'Li-nyama_nyama'
    },
    'Mokoko (Scarabée)': {
        translation: 'Scarabée',
        translationEn: 'Beetle',
        illustration: '🪲',
        audio: 'Li-mokoko'
    }
};

export default animaux;
